import { Box, HStack, Text, VStack } from "@chakra-ui/react";

interface CandidateInfoProps {
  name: string;
  title: string;
}

export function CandidateInfo({ name, title }: CandidateInfoProps) {
  return (
    <HStack gap={2} flexShrink={0} display={{ base: "none", md: "flex" }}>
      <Box
        boxSize="8"
        rounded="full"
        bg="indigo.600"
        display="flex"
        alignItems="center"
        justifyContent="center"
        fontSize="sm"
        fontWeight="bold"
        color="white"
        flexShrink={0}
        shadow="shadow-primary-xl"
        border="0.5px solid"
        borderColor="whiteAlpha.100"
      >
        {name.charAt(0)}
      </Box>
      <VStack gap={0} align="flex-start">
        <Text
          fontSize="sm"
          letterSpacing="0.05rem"
          fontWeight="regular"
          color="neutral.100"
          lineHeight="1"
        >
          {name}
        </Text>
        <Text fontSize="2xs" color="neutral.400" lineHeight="1.3" mt="0.1rem">
          {title}
        </Text>
      </VStack>
    </HStack>
  );
}
